import ReportPage from './ReportPage'

export default function ApuracaoReport({className = ''}: {className?: string}) {
  return <ReportPage type='apuracao' className={className} />
}
